export const BUSINESS_TYPES = [
  { id: 'product', label: 'Produtos' },
  { id: 'service', label: 'Serviços' },
];

export const SEGMENTS = {
  product: [
    { id: 'moda', label: 'Moda e vestuário' },
    { id: 'alimentos', label: 'Alimentos e bebidas' },
    { id: 'eletronicos', label: 'Eletrônicos' },
    { id: 'casa', label: 'Casa e decoração' },
    { id: 'outros', label: 'Outros' },
  ],
  service: [
    { id: 'beleza', label: 'Beleza e estética' },
    { id: 'saude', label: 'Saúde e bem-estar' },
    { id: 'consultoria', label: 'Consultoria' },
    { id: 'educacao', label: 'Educação' },
    { id: 'outros', label: 'Outros' },
  ],
};

const COLORS = ['#1F93FF', '#00BF8D', '#FFA723', '#EB5A46'];

const buildFunnel = titles =>
  titles.map((title, index) => ({ title, color: COLORS[index] }));

// The first stage of every funnel ("novo contato" / "novo pedido" / "novo lead")
// is intentionally left out: in the kanban, contacts with no label at all are
// already shown as the entry stage, so creating a real label for it would be redundant.
export const FUNNEL_PRESETS = {
  moda: buildFunnel([
    'Interessado',
    'Provou / experimentou',
    'Aguardando pagamento',
    'Cliente fidelizado',
  ]),
  alimentos: buildFunnel([
    'Confirmando itens',
    'Pagamento pendente',
    'Em preparo',
    'Entregue',
  ]),
  eletronicos: buildFunnel([
    'Dúvida técnica',
    'Orçamento enviado',
    'Aguardando pagamento',
    'Venda concluída',
  ]),
  casa: buildFunnel([
    'Visualizando catálogo',
    'Orçamento enviado',
    'Negociação',
    'Venda concluída',
  ]),
  beleza: buildFunnel([
    'Agendamento solicitado',
    'Agendado',
    'Atendido',
    'Cliente recorrente',
  ]),
  saude: buildFunnel(['Triagem', 'Agendado', 'Atendido', 'Retorno agendado']),
  consultoria: buildFunnel([
    'Diagnóstico',
    'Proposta enviada',
    'Negociação',
    'Contrato fechado',
  ]),
  educacao: buildFunnel([
    'Interessado no curso',
    'Matrícula em análise',
    'Pagamento pendente',
    'Matriculado',
  ]),
  outros: buildFunnel([
    'Qualificação',
    'Proposta enviada',
    'Negociação',
    'Fechado',
  ]),
};

export const DEFAULT_ATTRIBUTES = [
  {
    attribute_display_name: 'CPF/CNPJ',
    attribute_key: 'cpf_cnpj',
    attribute_display_type: 'text',
    attribute_model: 'contact_attribute',
  },
  {
    attribute_display_name: 'Cidade',
    attribute_key: 'cidade',
    attribute_display_type: 'text',
    attribute_model: 'contact_attribute',
  },
  {
    attribute_display_name: 'Origem UTM',
    attribute_key: 'origem_utm',
    attribute_display_type: 'text',
    attribute_model: 'contact_attribute',
  },
];

export const buildQuickReplies = ({ companyName, segmentLabel, pixKey }) => {
  const replies = [
    {
      short_code: 'boas-vindas',
      content: `Olá! Bem-vindo(a) à ${companyName || 'nossa loja'}. Como podemos ajudar você hoje?`,
    },
    {
      short_code: 'horario',
      content: `Nosso horário de atendimento é de segunda a sexta, das 9h às 18h. Em breve retornaremos seu contato!`,
    },
  ];

  if (segmentLabel) {
    replies.push({
      short_code: 'catalogo',
      content: `Temos diversas opções em ${segmentLabel}. Posso te enviar nosso catálogo?`,
    });
  }

  if (pixKey) {
    replies.push({
      short_code: 'chave-pix',
      content: `Nossa chave Pix para pagamento é: ${pixKey}`,
    });
  }

  return replies;
};
